/******************************************************************
 * Copyright (C) 2015--2018, 2023 VMware, Inc. All rights reserved.
 ******************************************************************/
/**
 * @fileoverview rtavsettings.js -- settings
 * settings for rtav feature
 * will support setter and getter for run time change in the later patch
 */

import RTAV from './logservice';

const settings = {
   // the default setting will be used only when no any agent setting read.
   video: {
      defMaxFPS: 30,
      defResWidth: 320,
      defResHeight: 240
   },
   audio: {
   },
   enabled: true,
   killSwitchOn: true
};

RTAV.settings = settings;
